import React from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Radio
} from "@material-ui/core";
import { TFunction } from "react-i18next";
import { ILocalTest } from "./helpers";

interface IChooseResultModalProps {
    open: boolean;
    resultsList: CompleoShared.Assessments.IPossibleResults[];
    testData: {
        testId: string;
        testName: string;
        testType: CompleoShared.Assessments.testType;
        templateUUID?: string;
        compleoModelId?: string;
    };
    handleClose: () => void;
    handleAddTest: (test: ILocalTest) => void;
    t: TFunction;
}

const ChooseResultModal = (props: IChooseResultModalProps) => {
    const {
        open,
        resultsList,
        handleClose,
        handleAddTest,
        t,
        testData
    } = props;
    const [selectedValue, setSelectedValue] = React.useState(
        resultsList[0]?.name || ""
    );

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedValue(event.target.value);
    };

    const handleSave = () => {
        const newTest: ILocalTest = {
            testId: testData.testId,
            testName: testData.testName,
            testType: testData.testType,
            possibleResults: resultsList,
            answersToResultsNameToCalculateScore: selectedValue,
            compleoModelId: testData.compleoModelId,
            templateUUID: testData.templateUUID
        };
        handleAddTest(newTest);
        handleClose();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="choose-result-dialog-title"
            disableEscapeKeyDown
            disableBackdropClick
        >
            <DialogTitle id="choose-result-dialog-title">
                {t("AddTestToAssessmentChooseResultModal_ModalTitle", {
                    ns: "TESTNEW"
                })}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {t(
                        "AddTestToAssessmentChooseResultModal_ModalInstructions",
                        {
                            ns: "TESTNEW"
                        }
                    )}
                </DialogContentText>
                <List>
                    {resultsList.map((result) => (
                        <ListItem
                            key={result.name}
                            button
                            onClick={() => setSelectedValue(result.name)}
                        >
                            <ListItemIcon>
                                <Radio
                                    checked={selectedValue === result.name}
                                    onChange={handleChange}
                                    value={result.name}
                                    name="radio-button-result"
                                    inputProps={{
                                        "aria-label": result.name
                                    }}
                                />
                            </ListItemIcon>
                            <ListItemText
                                primary={result.name}
                                secondary={
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: result.description || ""
                                        }}
                                    />
                                }
                            />
                        </ListItem>
                    ))}
                </List>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="secondary">
                    {t("COMPLEOGENERAL_CANCEL")}
                </Button>
                <Button
                    onClick={handleSave}
                    color="primary"
                    variant="contained"
                >
                    {t("COMPLEOGENERAL_SAVE")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ChooseResultModal;
